/**
 * The kinds of clothing a usual size is kept for, and the sizes it may be.
 */

export type UsualSizeKind = 'top' | 'bottom' | 'sweatshirt' | 'sportsBra'

export const USUAL_SIZE_KINDS: readonly { key: UsualSizeKind, labelKey: string }[] = [
  { key: 'top', labelKey: 'account.sizes.usual.kind.top' },
  { key: 'bottom', labelKey: 'account.sizes.usual.kind.bottom' },
  { key: 'sweatshirt', labelKey: 'product.category.sweatshirt' },
  { key: 'sportsBra', labelKey: 'product.category.sportbra' },
]

/**
 * Mirrors `USUAL_SIZE_VALUES` in vendure-app's customer-size-profile plugin, which refuses any
 * other value: every letter size the catalogue sells clothing in, smallest first.
 */
export const USUAL_SIZE_VALUES = ['XXS', 'XS', 'S', 'M', 'L', 'XL', 'XXL', 'XXXL'] as const
